<template>

    <ModalContainer :visible="visible" :loading="loading" :has-additional-top-margin="true">
        <template v-slot:header>
            <a class="btn btn-default btn-sm" id="delete_filters" @click.prevent.stop="removeFilterAppointmentsAdmin">
                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                Cancella Filtri
            </a>
            <button type="button" class="close" @click="$emit('close-filter-appointments-modal')"><span
                    aria-hidden="true">&times;</span></button>
        </template>
        <template v-slot:body>
            <div class="form-horizontal">
                <div class="form-group">
                    <label for="appointment_date" class="col-xs-12 col-md-4 control-label">Data</label>
                    <div class="col-xs-12 col-md-8 has-feedback" >
                        <Datetime id="appointment_date"
                                  type="date"
                                  :value-zone="TIMEZONE_DEFAULT"
                                  :zone="TIMEZONE_DEFAULT"
                                  v-model="filter.date"
                                  :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                                  input-class="form-control"></Datetime>
                        <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
                    </div>
                </div>
                <div class="form-group" v-if="myUser.show_only_my_reservations === false">
                    <label for="client-admins" class="col-xs-12 col-md-4 control-label">Utente</label>
                    <div class="col-xs-12 col-md-8">
                        <select class="form-control" id="client-admins" name="client-admin-options"
                                v-model="filter.admin">
                            <option :value="null">Appuntamenti di tutti
                            </option>
                            <option v-for="clientAdmin in clientsAdminAvailable" v-bind:key="clientAdmin.id"
                                    :value="clientAdmin.id">
                                {{ clientAdmin.first_name }} {{ clientAdmin.last_name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label for="client-admin-rates" class="col-xs-12 col-md-4 control-label">Classe</label>
                    <div class="col-xs-12 col-md-8">
                        <select class="form-control" id="client-admin-rates" name="client-admin-options"
                                v-model="filter.rate">
                            <option :value="null">Tutte le classi
                            </option>
                            <option v-for="rate in rates" v-bind:key="rate.id" :value="rate.id">
                                {{ rate.name }}
                            </option>
                        </select>
                    </div>
                </div>

            </div>
        </template>
        <template v-slot:footer>
            <a @click.prevent.stop="filterAppointments" class="btn btn-primary btn-lg btn-block" id="apply_filters">
                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
                Applica Filtri
            </a>
        </template>
    </ModalContainer>

</template>

<script>
import ModalContainer from "./ModalContainer"
import {Datetime} from "vue-datetime";
import 'vue-datetime/dist/vue-datetime.css'
import {getAllClientAdmin, getAllRates} from "../../api";
import {StorageHelper} from "../../common/storageHelper";
import {TIMEZONE_DEFAULT} from "../../common/constants";

export default {
    name: "AppointmentsAdminFilterModal",
    components: {ModalContainer,Datetime},
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    data: () => {
        return {
            loading: false,
            clientsAdminAvailable: [],
            TIMEZONE_DEFAULT: StorageHelper.getUser().timezone || TIMEZONE_DEFAULT,
            rates: [],
            myUser: StorageHelper.getUser(),
            filter: {
                date: null,
                admin: null,
                rate: null,
            },
            defaultFilter: {
                date: null,
                admin: null,
                rate: null,
            }
        }
    },
    methods: {
        filterAppointments() {
            this.$emit('filter-appointments-callback', this.filter)
            this.$emit('close-filter-appointments-modal')
        },
        removeFilterAppointmentsAdmin() {
            this.filter = this.defaultFilter;
            this.$emit('remove-filter-appointments-callback', this.defaultFilter)
            this.$emit('close-filter-appointments-modal')
        },
    },
    async mounted() {
        this.filter.admin = StorageHelper.getUser().id;
        this.defaultFilter.admin = StorageHelper.getUser().id;
        this.clientsAdminAvailable = await getAllClientAdmin();
        this.rates = await getAllRates();
    }
}
</script>
